
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_108wz_3",
  "button": "awsui_button_vjswe_108wz_7",
  "variant-normal": "awsui_variant-normal_vjswe_108wz_27",
  "is-activated": "awsui_is-activated_vjswe_108wz_40",
  "variant-icon": "awsui_variant-icon_vjswe_108wz_67",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_108wz_67",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_108wz_67",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_108wz_85",
  "disabled": "awsui_disabled_vjswe_108wz_103",
  "variant-primary": "awsui_variant-primary_vjswe_108wz_111",
  "variant-link": "awsui_variant-link_vjswe_108wz_195",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_108wz_615",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_108wz_702",
  "button-no-text": "awsui_button-no-text_vjswe_108wz_786",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_108wz_790",
  "icon-left": "awsui_icon-left_vjswe_108wz_806",
  "icon-right": "awsui_icon-right_vjswe_108wz_811",
  "icon": "awsui_icon_vjswe_108wz_806"
};
  